// extracted by mini-css-extract-plugin
export default {"line":"default_line__tdUDA","line__value":"default_line__value__OFXKn","line__aside":"default_line__aside__u4lEJ"};